module.exports = __webpack_public_path__ + "img/forgot-password.45c01aa0.svg";